export const phoneReg = /^(?:0|86|＋?86)?1[3-9]\d{9}$/;
export const CEReg = /^[\u4E00-\u9FA5A-Za-z]+$/; //匹配中英文
